module.exports = __webpack_public_path__ + "static/media/warning.0bfb0413.svg";